import {
  ButtonOneTapAuthEventsSDK,
  DataPolicyEventsSDK,
  FloatingOneTapAuthEventsSDK,
} from '@vkontakte/superappkit/dist/connect/events'

import { OneTapAuthEventsSDK } from '@vkontakte/superappkit'

export type CallbackHandler = (props: CallbackProps) => void

export interface CallbackProps {
  uuid: string
  token: string
  first_name: string
}

export enum VkAuthType {
  BUTTON = 'BUTTON',
  WINDOW = 'WINDOW',
}

export type CallbackType =
  | OneTapAuthEventsSDK
  | FloatingOneTapAuthEventsSDK
  | ButtonOneTapAuthEventsSDK
  | DataPolicyEventsSDK
